import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  VisibilityRounded,
} from "@mui/icons-material";
import configServ from "../../services/config";
import EnquiryDialog from "./EnquiryDialog";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const EnquiryTable = () => {
  const [enquiryList, setEnquiryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openRows, setOpenRows] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);

  const fetchEnquiryList = async () => {
    try {
      setLoading(true);
      const res = await configServ.getGroupedEnquiries(); // update if any params
      if (res.status === 200 && Array.isArray(res.data)) {
        setEnquiryList(res.data);
      } else {
        setEnquiryList([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiryList();
  }, []);

  const toggleRow = (email) => {
    setOpenRows((prev) => ({ ...prev, [email]: !prev[email] }));
  };

  if (loading) {
    return <CircularProgress />;
  }

  const handleView = (enq) => {
    console.log("handleView", enq);
    setSelectedEnquiry(enq);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <EnquiryDialog
        open={open}
        onClose={handleClose}
        enquiryData={selectedEnquiry}
        onsuccess={fetchEnquiryList}
      />

      <TableContainer
        component={Paper}
        sx={{ display: { xs: "none", sm: "block" } }}
      >
        <Table aria-label="enquiry table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#4cb5f5" }}>
              <TableCell />
              <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                Email
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                Total Enquiries
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {enquiryList.map((user) => (
              <React.Fragment key={user.email}>
                <TableRow>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => toggleRow(user.email)}
                    >
                      {openRows[user.email] ? (
                        <KeyboardArrowUp />
                      ) : (
                        <KeyboardArrowDown />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    {user.email}
                    {user.enquiries.some(
                      (enq) =>
                        enq.status === "pending" ||
                        enq.status === "payment_sent"
                    ) && (
                      <NotificationsActiveIcon
                        sx={{
                          color: "orange",
                          marginLeft: 1,
                          animation: "ring 1.5s infinite",
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell>{user.enquiries.length}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={6}
                  >
                    <Collapse
                      in={openRows[user.email]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box margin={2}>
                        <Typography variant="h6" gutterBottom>
                          Enquiries
                        </Typography>
                        <Table size="small" aria-label="enquiry-details">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#4cb5f5" }}>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "white" }}
                              >
                                Course Title
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "white" }}
                              >
                                Name
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  color: "white",
                                  display: { xs: "none", sm: "table-cell" },
                                }}
                              >
                                Phone
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  color: "white",
                                  display: { xs: "none", sm: "table-cell" },
                                }}
                              >
                                Status
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  color: "white",
                                  display: { xs: "none", sm: "table-cell" },
                                }}
                              >
                                Amount
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  color: "white",
                                  display: { xs: "none", sm: "table-cell" },
                                }}
                              >
                                Created At
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "white" }}
                              >
                                Action
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {user.enquiries.map((enq) => (
                              <TableRow key={enq.id}>
                                <TableCell>{enq.course_title}</TableCell>
                                <TableCell>{enq.name}</TableCell>
                                <TableCell
                                  sx={{
                                    display: { xs: "none", sm: "table-cell" },
                                  }}
                                >
                                  {enq.phone}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    display: { xs: "none", sm: "table-cell" },
                                  }}
                                >
                                  {enq.status}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    display: { xs: "none", sm: "table-cell" },
                                  }}
                                >
                                  {enq.discount_price}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    display: { xs: "none", sm: "table-cell" },
                                  }}
                                >
                                  {new Date(enq.created_at).toLocaleString()}
                                </TableCell>
                                <TableCell>
                                  <VisibilityRounded
                                    onClick={() => handleView(enq)}
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* 📱 Mobile Card Layout */}
      <Box sx={{ display: { xs: "block", sm: "none" }, p: 1 }}>
        {enquiryList.map((user) => (
          <Paper key={user.email} sx={{ p: 2, mb: 2 }}>
            {/* Header with Email + Expand/Collapse */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography variant="subtitle1" fontWeight="bold">
                {user.email}
                {user.enquiries.some(
                  (enq) =>
                    enq.status === "pending" || enq.status === "payment_sent"
                ) && (
                  <NotificationsActiveIcon
                    sx={{
                      color: "orange",
                      marginLeft: 1,
                      animation: "ring 1.5s infinite",
                    }}
                  />
                )}
              </Typography>
              <IconButton size="small" onClick={() => toggleRow(user.email)}>
                {openRows[user.email] ? (
                  <KeyboardArrowUp />
                ) : (
                  <KeyboardArrowDown />
                )}
              </IconButton>
            </Box>

            <Typography variant="body2">
              Total Enquiries: {user.enquiries.length}
            </Typography>

            {/* Collapse for Enquiries */}
            <Collapse in={openRows[user.email]} timeout="auto" unmountOnExit>
              {user.enquiries.map((enq) => (
                <Paper
                  key={enq.id}
                  sx={{
                    p: 1,
                    mt: 1,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="subtitle2">
                    {enq.course_title}
                  </Typography>
                  <Typography variant="body2">Name: {enq.name}</Typography>
                  <Typography variant="body2">Status: {enq.status}</Typography>
                  <Typography variant="body2">
                    Amount: ₹{enq.discount_price}
                  </Typography>
                  <Typography variant="caption" display="block" gutterBottom>
                    {new Date(enq.created_at).toLocaleString()}
                  </Typography>

                  {/* Action Button */}
                  <IconButton
                    size="small"
                    onClick={() => handleView(enq)}
                    sx={{ mt: 0.5 }}
                  >
                    <VisibilityRounded />
                  </IconButton>
                </Paper>
              ))}
            </Collapse>
          </Paper>
        ))}
      </Box>
    </>
  );
};

export default EnquiryTable;
